import {
  MutateOptions,
  UseMutateFunction,
  useMutation,
  useQueryClient,
} from '@tanstack/react-query';

import {
  QuizToastActions,
  apiToaster,
} from '~teacher/components/quizzes/toastActions/';
import {
  purgeQuizzesFoldersFromCache,
  quizzesQueryKey,
} from '~teacher/hook/useQuizzes';

import {
  PurgeQuizFolderParam,
  PurgeQuizResponse,
  purgeQuizFolder,
} from '../../api/quiz/purgeQuizFolder/purgeQuizFolder';

export function usePurgeQuizFolder(items: string[]) {
  const queryClient = useQueryClient();
  return useMutation(purgeQuizFolder, {
    onMutate: async (purgeQuizFolderParams: PurgeQuizFolderParam) => {
      const oldCache = queryClient.getQueryData(quizzesQueryKey.quiz);

      // Cancel any outgoing refetches (so they don't overwrite our optimistic update)
      await queryClient.cancelQueries(quizzesQueryKey.quiz);
      purgeQuizzesFoldersFromCache(
        queryClient,
        purgeQuizFolderParams.quizIds,
        purgeQuizFolderParams.folderIds
      );
      return { oldCache };
    },

    onError: (error, newCache, ctx) => {
      apiToaster([...items], QuizToastActions.PURGE, error);
      queryClient.setQueryData(quizzesQueryKey.quiz, ctx.oldCache);
    },
    onSettled: () => {
      return queryClient.invalidateQueries(quizzesQueryKey.quiz);
    },
  });
}

export type PurgeQuizError = unknown;

export type PurgeQuizFolderMutation = UseMutateFunction<
  PurgeQuizResponse,
  PurgeQuizError,
  PurgeQuizFolderParam
>;

export type PurgeQuizFolderOptions = MutateOptions<
  PurgeQuizResponse,
  PurgeQuizError,
  PurgeQuizFolderParam
>;
